var NavFactory = require('./nav-factory');
var NavDataAccess = require('./nav-data-access');
var NavPopulator = require('./nav-populator');
var NavDomElements = require('./nav-dom-elements');

var SponsorshipConst = require('src/interlock/nav-sponsorship/constants');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var darklaunch = require('src/interlock/no-ui/utils/darklaunch/darklaunch');

var NavController = function() {
    var _self = this;

    this.makeAnchorSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var makeNiceName = $( dom ).data('makeNiceName');
        var type = $( dom ).data('type');
        var makeName = $( dom ).data('makeName');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setMake({
            niceName: makeNiceName,
            name: makeName
        });
        var headerMake = mmyDivs.modelsDiv.find('.nav-header .selected.make');
        headerMake.html(makeName);
        mmyDivs.makesDiv.addClass('hidden');
        mmyDivs.modelsDiv.find('.list').empty().hide();
        mmyDivs.modelsDiv.removeClass('hidden');
        NavDataAccess.getModelYear({
            makeNiceName: makeNiceName,
            type: type
        }, function() {
            NavPopulator.populateModels( _self, parentId, type );
        });
    };
    
    this.modelAnchorSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var type = $( dom ).data('type');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setModel({
            niceName: $( dom ).data('modelNiceId'),
            name: $( dom ).data('modelName')
        });
        NavFactory.setSubmodel({
            niceName: $( dom ).data('submodelNiceName'),
            name: $( dom ).data('submodelName')
        });
        var headerMake = mmyDivs.yearsDiv.find('.nav-header .selected.make');
        var headerModel = mmyDivs.yearsDiv.find('.nav-header .selected.model');
        headerMake.html(NavFactory.getSelected().make.name);
        headerModel.html(NavFactory.getSelected().submodel.name);
        mmyDivs.makesDiv.addClass('hidden');
        mmyDivs.modelsDiv.addClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty();
        mmyDivs.yearsDiv.removeClass('hidden');
        NavPopulator.populateYears( _self, parentId, type );

        this.fireGlobalNavImpressionTracking(parentId);
    };

    this.makeHeaderSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        NavFactory.resetSelected();
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        mmyDivs.makesDiv.removeClass('hidden');
        mmyDivs.modelsDiv.find('.list').empty().hide();
        mmyDivs.modelsDiv.addClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty().hide();
        mmyDivs.yearsDiv.addClass('hidden');

    };

    this.modelHeaderSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setModel({});
        NavFactory.setYear({});
        mmyDivs.modelsDiv.removeClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty().hide();
        mmyDivs.yearsDiv.addClass('hidden');
    };

    this.fireGlobalNavImpressionTracking = function (tabId) {
        var tab_id = tabId.slice(1);

        if(SponsorshipConst.NAV_ITEMS.indexOf(tab_id) > -1) {
            if(darklaunch.storyEnabled('TMT-207')) {
                eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {tabId: '#' + tab_id});
            } else {
                eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {tabId: tab_id});
            }
        }
    };
};


module.exports = new NavController();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-controller.js
// module id = 72
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14